export default __webpack_public_path__ + "static/media/scrum-study-cards-deck-2.98873d14.png";